import tenantUtils from '@utils';
import { getUnifiedTruLeadsStaffDateRangeFilterItem } from '../utils/unifiedTruLeadsLeadFilters';
import { getTimeDateString } from '../../../utility/date';
import { isUnifiedProfolioEnabled } from '../../../utility/user';
import { t } from 'i18next';

const defaultLeadDateRangeFilters = [
  {
    label: 'Lead Received',
    key: 'lead_received',
    queryParamKey: ['q[created_at_gteq]', 'q[created_at_lteq]'],
    placeholder: 'Select Date Range',
    type: 'dateRange',
    getOptionLabel: (value) => {
      return value
        .split(',')
        .map((e) => getTimeDateString(e, false, true, false, false))
        .join(' - ');
    },
  },
  {
    label: 'Last Interaction',
    key: 'last_interaction',
    queryParamKey: ['q[updated_at_gteq]', 'q[updated_at_lteq]'],
    placeholder: 'Select Date Range',
    type: 'dateRange',

    getOptionLabel: (value) => {
      return value
        .split(',')
        .map((e) => getTimeDateString(e, false, true, false, false))
        .join(' - ');
    },
  },
];

const getLeadsStaffFilters = (users) => [
  {
    type: 'unitSelect',
    label: 'Search By',
    key: 'search',
    subList: [
      { label: t('Listing ID'), key: 'listing_id', queryParamKey: 'q[interests_listing_id_eq]' },
      { label: t('REGA Ad License Number'), key: 'ad_license', queryParamKey: 'q[interests_listing_ad_license_eq]' },
      { label: t('Lead ID'), key: 'lead_id', queryParamKey: 'q[lead_client_id_eq]' },
      { label: t('Lead Name'), key: 'lead_name', queryParamKey: 'q[name_start]' },
    ],
  },
  ...(isUnifiedProfolioEnabled({ featureKey: 'listingsUnified' })
    ? [getUnifiedTruLeadsStaffDateRangeFilterItem()]
    : defaultLeadDateRangeFilters),
  ...(users?.length > 1
    ? [
        {
          key: 'user_id',
          queryParamKey: 'q[user_id_eq]',
          label: 'Users',
          labelProps: { muted: true },
          placeholder: 'Select Users',
          type: 'select',
          list: users,
          showTag: true,
          singleValue: true,
          getOptionLabel: (e) => tenantUtils.getLocalisedString(e, 'name'),
          getOptionValue: (op) => op.id.toString(),
        },
      ]
    : []),

  // {
  //   key: 'product_id',
  //   queryParamKey: 'q[product_id_in][]',
  //   label: 'Task Performed',
  //   labelProps: { muted: true },
  //   placeholder: 'Select Task Performed',
  //   type: 'select',
  //   showTag: true,
  //   singleValue: true,
  //   getOptionLabel: (e) => tenantUtils.getLocalisedString(e, 'product_title'),
  // },
  // {
  //   key: 'product_id',
  //   queryParamKey: 'q[product_id_in][]',
  //   label: 'Planned Task',
  //   labelProps: { muted: true },
  //   placeholder: 'Select Planned Task',
  //   type: 'select',
  //   showTag: true,
  //   singleValue: true,
  //   getOptionLabel: (e) => tenantUtils.getLocalisedString(e, 'product_title'),
  // },
];
export default getLeadsStaffFilters;
